import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { convertToFixedNumberOfDecimals } from '~/utils/math-helper';

@Component({})
export default class OpportunityBudgetRequestComponent extends Vue {
    private isTotal: boolean = true;

    @Prop()
    private opportunity: any;
    @Prop()
    private elementIndex: number;

    constructor() {
        super();
    }

    private convertToFixedNumberOfDecimals = (value: number) => convertToFixedNumberOfDecimals(value)

    private changeTotal(index: number) {
        this.isTotal = !this.isTotal;
    }

    private emitCopy(index: number) {
        this.$emit('copy', index);
    }
}
